import React from "react";
import StarIcon from "material-ui/svg-icons/action/stars";

const containerStyle = {
  width: 50,
  textAlign: "center",
  padding: "0px 10px",
  height: 30,
  overflow: "hidden",
  flex: 1,
  maxWidth: 50
};

const starIconColor = "rgb(255, 161, 0)";
const noStarIconColor = "#d4d4d4";
const iconStyle = {
  cursor: "pointer",
  marginTop: 2
};

const Star = ({ starred, onClick, readOnly, style }) => (
  <div
    style={{
      ...containerStyle,
      overflow: "hidden",
      whiteSpace: "nowrap",
      ...style
    }}
  >
    {!!starred ? (
      <StarIcon style={{...iconStyle, ...style}} color={starIconColor} onClick={onClick} />
    ) : (
      <StarIcon
        className="add-star-inline"
        onClick={onClick}
        style={{...iconStyle, ...style}}
        color={!!starred ? starIconColor : noStarIconColor}
        style={{
          cursor: readOnly ? 'default' : 'pointer',
          display: readOnly ? 'none' : 'inline'
        }}
      />
    )}
  </div>
);

Star.style = containerStyle;

export default Star;
